export const SidebarBtn = ({position, open}) => {
    return (
        <button className={`header-btn ${position}`} onClick={open}>
            <img src="/assets/icons/hamburger.svg" alt="contact open button"/>
        </button>
    );
};

export default SidebarBtn;
